<template>
  <div>
    <cc-search-bar
      v-bind:reload.sync="loadSearch"
      :groups="groups"
      :static-groups="staticGroups"
      :items="items"
      :options="options"
      v-model="searchResults"
    ></cc-search-bar>
  </div>
</template>

<script>
import api from "../api";

export default {
    name : 'search-bar-wrapper',
    props : {
      searchItems : {
        type : Array
      },
      options : {
        type: Object
      },
      filter : {
        type : Boolean,
        default : false,
      }
    },
    data(){
      return{
        searchResults : [],
        items : [],
        groups : [
          {
            name : "Name",
            condition : 'OR',
            model : 'name',
            text_color: "#4883f7",
            color: "#f2f3f5"
          },
          {
            name: "Created By",
            condition: 'OR',
            model: 'created_by_name',
            text_color: "#4883f7",
            color: "#f2f3f5"
          },
          {
            name: "Updated By",
            condition: 'OR',
            model: 'updated_by_name',
            text_color: "#4883f7",
            color: "#f2f3f5"
          },
          {
            name: "Labels",
            condition: 'OR',
            model: 'labels',
            text_color: "#4883f7",
            color: "#f2f3f5"
          },
        ],
        staticGroups : [
        ],
        loadSearch : false,
      }
    },
    methods: {
      init(){
        this.groups[0].name = this.$t('common:single_word.name','Name');
        this.groups[1].name = this.$t('common:phrase.created_by','Created By');
        this.groups[2].name = this.$t('common:phrase.updated_by','Updated By');
        this.groups[3].name = this.$t('common:single_word.labels','Labels');
        this.loadSearch = true;
      },
      transformData(items){
        this.items = items;
        this.loadSearch = true;
      },
      buildStaticGroups(){
      },
    },
    computed: {
    },
    watch : {
      searchResults(){
        this.$emit("input", this.searchResults.results);
      },
      filter(newVal){
        if(newVal){

          // this.buildStaticGroups();
          this.transformData(this.searchItems);

          this.loadSearch = true;
          this.$emit('update:filter', false);   
        }
      },
      searchItems: {
        deep: true,
        handler(newVal) {
          this.transformData(newVal);
        }
      },
    },
    mounted(){
      this.init()
    }    
}
</script>

<style scoped>

</style>
